enum RightBlockSourceType {
  PLAYLIST = 'playlist',
  LESSON = 'lesson',
  MODULE = 'module',
}
export default RightBlockSourceType;
